import { Component, Event, EventEmitter, Listen } from "@stencil/core";
import { getWishlists, setWishlists } from "@stores/wishlist.store";
import { AddToWishlistEventDetails } from "../../../../../components/wishlist/bcp-add-to-wishlist/bcp-add-to-wishlist-model";

@Component({
  tag: "f-wishlist-proxy",
})
export class MiniInquiryProxy {
  @Event() productAddedToWishlist: EventEmitter<AddToWishlistEventDetails>;

  @Listen("onWishlistChange", { target: "window" })
  handleOrderChange(event: CustomEvent): void {
    if (event.detail && event.detail.data) {
      setWishlists(event.detail.data);
      this.productAddedToWishlist.emit();
    } else {
      getWishlists().then(() => {
        this.productAddedToWishlist.emit();
      });
    }
  }
}
